import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './globalStore'


Vue.config.productionTip = false

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.min.css'

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
